import RemoteEvaluateResult from "./RemoteEvaluateResult"
import Evaluation from "../../../evaluation/Evaluation"
import Entity from "../../../model/Entity"
import {
  DecisionReason,
  AbstractExperiment,
  ExperimentStatus,
  ExperimentType,
  Long,
  SplitUrlTargets,
  Variation
} from "../../../model/model"
import ExperimentEvaluation from "../../../evaluation/service/experiment/ExperimentEvaluation"
import { ExperimentEvaluateResult } from "../../../evaluation/service/experiment/ExperimentEvaluateResult"

/**
 * Server-resolved experiment result. Is both the entity (an `Experiment`) and its own
 * `ExperimentEvaluateResult`, and flattens into an `ExperimentEvaluation`.
 */
export default class ExperimentRemoteEvaluateResult
  extends AbstractExperiment
  implements RemoteEvaluateResult, ExperimentEvaluateResult
{
  constructor(
    readonly id: number,
    readonly key: number,
    readonly version: Long,
    readonly status: ExperimentStatus,
    readonly order: Long,
    readonly type: ExperimentType,
    readonly executionVersion: Long,
    readonly variation: Variation,
    readonly reason: DecisionReason,
    readonly references: Entity[],
    readonly targetUrls: SplitUrlTargets | undefined
  ) {
    super()
  }

  with(reason: DecisionReason): ExperimentEvaluateResult {
    return ExperimentEvaluateResult.of(reason, this.variation)
  }

  toEvaluation(): Evaluation {
    return new ExperimentEvaluation(this, this)
  }
}
